/**
 * 导出默认通用配置
 *
 * @author Shigq
 * @date 2020/12/3 19:07
 */
const setting = {
	// 开发以及部署时的URL
	publicPath: '',
	// 生产环境构建文件的目录名
	outputDir: 'dist',
	// 放置生成的静态资源 (js、css、img、fonts) 的 (相对于 outputDir 的) 目录。
	assetsDir: 'static',
	// 开发环境每次保存时是否输出为eslint编译警告
	lintOnSave: true,
	// 进行编译的依赖
	transpileDependencies: [],
	//标题 （包括初次加载雪花屏的标题 页面的标题 浏览器的标题）
	title: 'sunrate vue next',
	//所属系统名称
	systemTitle: 'sunrate next',
	//简写
	abbreviation: 'sr-next',
	//开发环境端口号
	devPort: '8080',
	//版本号
	version: '0.0.1',
	//这一项非常重要！请务必保留MIT协议下package.json及copyright作者信息 即可免费商用，不遵守此项约定你将无法使用该框架，如需自定义版权信息请联系QQ1204505056
	copyright: 'vab',
	//是否显示页面底部自定义版权信息
	footerCopyright: true,
	//是否显示顶部进度条
	progressBar: true,
	//不经过token校验的路由
	routesWhiteList: ['/login', '/register', '/forgetPassword', '/404'],
	//token名称 - 根据系统来（和顶级域名下token重名，会有问题，建议单独设置）
	tokenName: 'token',
	//token存储位置localStorage sessionStorage
	storage: 'localStorage',
	//是否开启登录拦截
	loginInterception: true,
	//是否开启登录RSA加密
	loginRSA: false,
	debounce: ['loading'],
}

module.exports = setting
